/**
 * 安全设置（占位，待接入具体能力）
 */
export function SecuritySettings() {
  return (
    <div className="flex flex-1 flex-col items-center justify-center p-8">
      <p className="text-center text-sm text-muted">安全设置内容开发中</p>
    </div>
  );
}
